import { watch } from "vue";
import model from "../model";
import cookieHelper from "../utils/cookie-helper";
import { minsToMills } from "../utils/utils";

const FOCUSED_IDLE_RELOAD_MS = minsToMills(60);
const AWAY_RELOAD_THRESHOLD_MS = minsToMills(30);

// Only applies to returning players browsing as a guest (i.e. this browser has logged in
// before, see the 'registered_player' cookie) - never to a first-time visitor, so nobody gets
// reloaded out from under a registration form.
function isReturningGuest(){
    return !model.uToken && Boolean(cookieHelper.get('registered_player'));
}

// Guests have no session state worth preserving, so unlike logged-in players it's safe to force a
// reload on a plain timer instead of reacting to specific app events. Logged-in players are
// untouched by any of this - the moment uToken is set, the timer is cleared and stays cleared.
export default {
    init(){
        let idleTimeout: ReturnType<typeof setTimeout> | undefined;
        let hiddenAt: number | undefined;
    
        watch(() => model.uToken, value => {
            clearIdleTimeout();
    
            if(value){
                hiddenAt = undefined;
                return;
            }
    
            onNavigation();
        }, {immediate: true});
    
        model.on('Navigation', onNavigation);
        watch(() => model.activeModal, onNavigation);
    
        document.addEventListener('visibilitychange', () => {
            clearIdleTimeout();
            if(!isReturningGuest()) return;
    
            if(document.visibilityState === 'hidden'){
                hiddenAt = Date.now();
                return;
            }
    
            if(hiddenAt !== undefined && Date.now() - hiddenAt >= AWAY_RELOAD_THRESHOLD_MS){
                location.reload();
                return;
            }
    
            hiddenAt = undefined;
            onNavigation();
        });
    
        function onNavigation(){
            clearIdleTimeout();
            if(!isReturningGuest() || document.visibilityState === 'hidden') return;
            idleTimeout = setTimeout(() => location.reload(), FOCUSED_IDLE_RELOAD_MS);
        }
    
        function clearIdleTimeout(){
            clearTimeout(idleTimeout);
            idleTimeout = undefined;
        }
    }
} 